<template>
    <div class="project-progress_page">
        <div class="valid-area m-b-16">
            <div class="project-list flex-ac flex-wrap">
                <div 
                v-for="project in projectList" 
                :key="project.projectId" 
                :class="[{'cur':curProjectId === project.projectId},'project','hide-txt']"
                @click="checkProject(project.projectId)">{{ project.projectName }}</div>
                <div class="p-l-24 fs18" v-if="projectList.length === 0 && !projectLoading">项目未配置，无法跟踪进度</div>
            </div>
        </div>
        <div class="valid-area m-b-24">
            <div class="table-mod">
                <div class="title flex-ac f6">
                    <img src="../../../assets/img/base_data.png" class="icon" alt="">
                    <div class="fs16">基础信息</div>
                </div>
                <div v-loading="baseLoading" v-if="baseInfo" class="m-b-28">
                    <div class="flex-sb m-b-10 flex-s0">
                        <div class="row row-width flex-sb">
                            <div class="label flex-s0 gray99">项目负责人：</div>
                            <div class="value flex-1">{{ baseInfo.chargePerson }}</div>
                        </div>
                        <div class="row flex-sb flex-1">
                            <div class="label flex-s0 gray99">项目成员：</div>
                            <div class="value flex-1">{{ baseInfo.member }}</div>
                        </div>
                    </div>
                    <div class="flex-sb flex-1">
                        <div class="row row-width flex-sb flex-s0"> 
                            <div class="label flex-s0 gray99">开始日期：</div>
                            <div class="value flex-1">{{ baseInfo.beginTime }}</div>
                        </div>
                        <div class="row flex-sb flex-1">
                            <div class="label flex-s0 gray99">项目简介：</div>
                            <div class="value flex-1">{{ baseInfo.projectIntroduction }}</div>
                        </div>
                    </div>
                </div>
                <div class="tabs flex-sb flex-ac">
                    <div class="tab tab1">
                        <div class="fs16 f7 m-b-24">累计采购</div>
                        <div class="flex-ac flex-sb">
                            <div class="data-item">
                                <div class="gray66 m-b-10">数量</div>
                                <div>
                                    <span class="fs20 f7 m-r-4">{{ baseTabData.cgCount | numFormat }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="gray66 m-b-10">金额</div>
                                <div class="hlg-red">
                                    <span class="fs20 f7 m-r-4">{{ baseTabData.cgMoney | moneyFormat }}</span>
                                    <span>{{ baseTabData.cgMoney_unit }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab tab2">
                        <div class="fs16 f7 m-b-24">当前库存</div>
                        <div class="flex-ac flex-sb">
                            <div class="data-item">
                                <div class="gray66 m-b-10">数量</div>
                                <div>
                                    <span class="fs20 f7 m-r-4">{{ baseTabData.kcCount | numFormat }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="gray66 m-b-10">金额</div>
                                <div class="hlg-red">
                                    <span class="fs20 f7 m-r-4">{{ baseTabData.kcMoney | moneyFormat }}</span>
                                    <span>{{ baseTabData.kcMoney_unit }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab tab3">
                        <div class="fs16 f7 m-b-24">累计分销</div>
                        <div class="flex-ac flex-sb">
                            <div class="data-item">
                                <div class="gray66 m-b-10">数量</div>
                                <div>
                                    <span class="fs20 f7 m-r-4">{{ baseTabData.xsCount | numFormat }}</span>
                                    <span>个</span>
                                </div>
                            </div>
                            <div class="data-item">
                                <div class="gray66 m-b-10">金额</div>
                                <div class="hlg-red">
                                    <span class="fs20 f7 m-r-4">{{ baseTabData.xsMoney | moneyFormat }}</span>
                                    <span>{{ baseTabData.xsMoney_unit }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!baseInfo && !baseLoading" class="gray7f">暂无数据</div>
            </div>
        </div>
        <div class="valid-area m-b-24" v-if="baseInfo.showCglist == 2">
            <div class="table-mod">
                <div class="title flex-sb">
                    <div class="flex-ac">
                        <img src="../../../assets/img/cg_data.png" class="icon" alt="">
                        <div class="f6">
                            <span class="fs16">采购数据</span>
                            <span class="fs12">（不含税_单位万）</span>
                        </div>
                    </div>
                    <div>
                        <el-button-group>
                            <el-button :disabled="globalYearMonth !== curYearMonth" plain size="mini" @click="getSubProjectCgData('week')" :type="cgInfoDataType === 'week' ? 'primary' : ''">本周</el-button>
                            <el-button plain size="mini" @click="getSubProjectCgData('month')" :type="cgInfoDataType === 'month' ? 'primary' : ''">本月</el-button>
                            <el-button plain size="mini" @click="getSubProjectCgData('season')" :type="cgInfoDataType === 'season' ? 'primary' : ''">本季</el-button>
                            <el-button plain size="mini" @click="getSubProjectCgData('year')" :type="cgInfoDataType === 'year' ? 'primary' : ''">本年</el-button>
                            <el-button plain size="mini" @click="getSubProjectCgData('sum')" :type="cgInfoDataType === 'sum' ? 'primary' : ''">累计</el-button>
                        </el-button-group>
                    </div>
                </div>
                <el-table 
                :data="cgTableData" 
                v-loading="cgTableLoading" 
                border
                :row-class-name="cgEndRowClassName"
                @row-click="row => showInfoDialog(row,4,cgInfoDataType)"
                style="width: 100%;font-size: 14px"
                :header-cell-style="{ 'font-weight': 400,background: '#EDF1F7' }">
                    <el-table-column prop="projectName" label="项目名称"> </el-table-column>
                    <el-table-column prop="saleMainName" label="业务员"> </el-table-column>
                    <el-table-column prop="publicName" label="合作商"> </el-table-column>
                    <el-table-column prop="gbml" label="采购数量">
                        <span slot-scope="scope">{{scope.row.cgCount | moneyFormat}}</span>
                    </el-table-column>
                    <el-table-column prop="gbml" label="采购金额">
                        <span slot-scope="scope">{{scope.row.cgMoney | moneyFormat}}</span>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="valid-area m-b-24">
            <div class="table-mod">
                <div class="title flex-sb">
                    <div class="flex-ac">
                        <img src="../../../assets/img/info_data.png" class="icon" alt="">
                        <div class="f6">
                            <span class="fs16">分销数据</span>
                            <span class="fs12">（不含税_单位万）</span>
                        </div>
                    </div>
                    <div>
                        <el-button-group>
                            <el-button :disabled="globalYearMonth !== curYearMonth" plain size="mini" @click="getSubProjectSaleData('week')" :type="fxInfoDataType === 'week' ? 'primary' : ''">本周</el-button>
                            <el-button plain size="mini" @click="getSubProjectSaleData('month')" :type="fxInfoDataType === 'month' ? 'primary' : ''">本月</el-button>
                            <el-button plain size="mini" @click="getSubProjectSaleData('season')" :type="fxInfoDataType === 'season' ? 'primary' : ''">本季</el-button>
                            <el-button plain size="mini" @click="getSubProjectSaleData('year')" :type="fxInfoDataType === 'year' ? 'primary' : ''">本年</el-button>
                            <el-button plain size="mini" @click="getSubProjectSaleData('sum')" :type="fxInfoDataType === 'sum' ? 'primary' : ''">累计</el-button>
                        </el-button-group>
                    </div>
                </div>
                <el-table 
                :data="fxTableData" 
                v-loading="fxTableLoading" 
                border
                :row-class-name="fxEndRowClassName"
                style="width: 100%;font-size: 14px"
                :header-cell-style="{ 'font-weight': 400,background: '#EDF1F7' }">
                    <el-table-column prop="projectName" label="项目名称" width="160"> </el-table-column>
                    <el-table-column prop="saleMainName" label="业务员" width="100"> </el-table-column>
                    <el-table-column prop="publicName" label="合作商" width="160"> </el-table-column>
                    <el-table-column prop="saleMoney" label="销售">
                        <div slot-scope="scope" class="can-click flex-ac" @click="showInfoDialog(scope.row,1,fxInfoDataType)">
                            <div>{{scope.row.saleMoney | moneyFormat}}</div>
                            <div class="arr"></div>
                        </div>
                    </el-table-column>
                    <el-table-column prop="mlMoney" label="分销总毛利">
                        <div slot-scope="scope" class="flex-ac">
                        <!-- <div slot-scope="scope" class="can-click flex-ac" @click="showInfoDialog(scope.row,2,fxInfoDataType)"> -->
                            <div>{{scope.row.mlMoney | moneyFormat}}</div>
                            <!-- <div class="arr"></div> -->
                        </div>
                    </el-table-column>
                    <el-table-column prop="cwsrMoney" label="财务收入">
                        <div slot-scope="scope" class="can-click flex-ac" @click="showInfoDialog(scope.row,3,fxInfoDataType)">
                            <div>{{scope.row.cwsrMoney | moneyFormat}}</div>
                            <div class="arr"></div>
                        </div>
                    </el-table-column>
                    <el-table-column prop="gbml" label="管报毛利">
                        <span slot-scope="scope">{{scope.row.gbml | moneyFormat}}</span>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="valid-area m-b-24">
            <div class="table-mod">
                <div class="title flex-sb">
                    <div class="flex-ac">
                        <img src="../../../assets/img/project.png" class="icon" alt="">
                        <div class="f6">
                            <span class="fs16">项目进度</span>
                        </div>
                    </div>
                    <div>
                        <el-select v-model="curUserId" size="small" @change="queryWeeklyByProject">
                            <el-option :value="''" label="所有成员"></el-option>
                            <el-option v-for="user in projectUserList" :key="user.userId" :value="user.userId" :label="user.userName"></el-option>
                        </el-select>
                    </div>
                </div>
                <!-- 报告流水 -->
                <div class="info-list" v-if="!weeklyListLoading && !weeklyList.length">暂无数据</div>
                <div class="info-list" v-loading="weeklyListLoading" v-if="weeklyList.length">
                    <!-- 月 -->
                    <div
                    class="month"
                    :class="{'cur': index === 0}"
                    v-for="(month,index) in weeklyList"
                    :key='month.weeklyMonth'>
                        <div class="title-month">{{month.weeklyMonth}}</div>
                        <!-- 周 -->
                        <div
                        class="week"
                        :class="{'cur': weekIndex === 0}"
                        v-for="(week,weekIndex) in month.weekList"
                        :key="week.weeklyDate">
                            <div class="title-week">{{week.weeklyDate}}</div>
                            <div class="border-lf"></div>
                            <!-- 部门 -->
                            <div
                            class="department"
                            :class="{'blue':departmentIndex%3 == 0,'blue-light':departmentIndex%3 == 1,'blue-lighter':departmentIndex%3 == 2}"
                            v-for="(department,departmentIndex) in week.deptList"
                            :key="department.deptId">
                                <div class="title-department">{{department.deptName}}</div>
                                <!-- 人 -->
                                <div
                                class="user"
                                v-for="user in department.userList"
                                :key="user.userId">
                                    <div class="label">{{user.userName}}：</div>
                                    <div class="val-list">
                                        <!-- 事项 -->
                                        <div class="val" v-html="user.projectKey"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="empty-weekly gray66" v-if="week.deptList.length === 0">本周暂无项目进展</div>
                        </div>
                    </div>
                    <div v-if="weeklyType === 'first_week'" class="load-more flex-ac" @click="loadMore"><img class="icon-more" src="../../../assets/img/more.png" alt="">点击查看历史进展</div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="disDialogVisible" width="92%" top="10vh" :title="disDialogTitle">
            <div class="flex-sb m-b-20">
                <div>
                    <div v-show="store.params.queryType === 'fx'">
                        订单类型：
                        <el-select v-model="store.params.orderType" @change="store.reload()">
                            <el-option label="全部" value="ALL"></el-option>
                            <el-option label="分销订单" value="分销订单"></el-option>
                            <el-option label="服务订单" value="服务订单"></el-option>
                            <el-option label="待收款单" value="待收款单"></el-option>
                            <el-option label="退货订单" value="退货订单"></el-option>
                            <el-option label="折让转利订单" value="折让转利订单"></el-option>
                        </el-select>
                    </div>
                </div>
                <el-pagination
                    background
                    :hide-on-single-page="true"
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :page-size="store.params.step"
                    :current-page="store.params.page"
                    :total="store.total"
                    :small="true"
                >
                </el-pagination>
            </div>
            <el-table :data="store.data" v-loading="store.loading" style="width: 100%;">
                <el-table-column prop="projectName" label="项目名称" width="100"> </el-table-column>
                <el-table-column prop="companyName" label="公司" width="80"> </el-table-column>
                <el-table-column prop="type" label="订单类型" width="100" v-if="store.params.queryType === 'fx'"> </el-table-column>
                <el-table-column prop="orderNum" label="订单号" width="160">
                    <div slot-scope="scope" @dblclick="copyString(scope.row.orderNum)">{{scope.row.orderNum}}</div>
                </el-table-column>
                <el-table-column prop="distName" label="客户" width="200" v-if="store.params.queryType === 'fx'"> </el-table-column>
                <el-table-column prop="hzs" label="合伙人" width="160"></el-table-column>
                <el-table-column prop="saleMoney" label="销售金额（无税）" width="150" sortable v-if="store.params.queryType === 'fx'">
                    <span slot-scope="scope" :class="{'green': scope.row.saleMoney < 0,'hlg':scope.row.saleMoney>0}" class="f7">{{scope.row.saleMoney | moneyFormat}}</span>
                </el-table-column>
                <el-table-column prop="mlMoney" label="毛利" width="100" sortable v-if="store.params.queryType === 'fx'">
                    <span slot-scope="scope" :class="{'green': scope.row.mlMoney < 0,'hlg':scope.row.mlMoney>0}" class="f7">{{scope.row.mlMoney | moneyFormat}}</span>
                </el-table-column>
                <el-table-column prop="money" label="财务收入" width="100" sortable v-if="store.params.queryType === 'cwsr'">
                    <span slot-scope="scope" :class="{'green': scope.row.money < 0,'hlg':scope.row.money>0}" class="f7">{{scope.row.money | moneyFormat}}</span>
                </el-table-column>
                <el-table-column prop="cgCount" label="采购数量" width="140" sortable v-if="store.params.queryType === 'cg'">
                    <span slot-scope="scope" class="f7">{{scope.row.cgCount | moneyFormat}}</span>
                </el-table-column>
                <el-table-column prop="cgMoney" label="采购金额" width="140" sortable v-if="store.params.queryType === 'cg'">
                    <span slot-scope="scope" class="f7">{{scope.row.cgMoney | moneyFormat}}</span>
                </el-table-column>
                <el-table-column prop="userName" label="业务员" width="80"> </el-table-column>
                <el-table-column prop="applyName" label="制单人" width="80"> </el-table-column>
                <el-table-column prop="applyTime" label="制单时间" width="150"> </el-table-column>
            </el-table>
        </el-dialog>
        <Siri
            :show-date-picker="true"
            @dateChange="globalDateChange"
            :date="globalYearMonth"
            :show-company-picker="true" 
            @companyChange="companyChange"
            :max-date="maxDate"
        />
    </div>
</template>

<script>
import utils from '../../../utils/utils';
import Siri from '../../common/dataPanel/Siri';

export default {
    name: 'projectProgress',
    data() {
        var curYearMonth = utils.getCurDate('Array')[0] + '-' + utils.getCurDate('Array')[1];
        var curYear = utils.getCurDate('Array')[0];
        var store = utils.DataSource({
            url: this.$api.getProjectOrderList.url,
            params: {
                projectId: '',
                projectId_sub: '',
                yearMonth: '',
                dateType: '',
                conpanyId: '',
                saleMainId: '',
                publicId: '',
                orderType: 'ALL',
                queryType: '',
                step: 10
            }
        })
        return {
            curYearMonth: curYearMonth,
            globalYearMonth: curYearMonth,
            maxDate: `${curYear}-12`,
            curCompany: {
                id: 'ALL',
                name: '所有公司'
            },
            store,

            projectLoading: false,
            projectList: [],
            curProjectId: '',
            baseInfo:'',
            baseLoading: false,
            fxInfoDataType: 'week',
            fxTableData: [],
            fxTableLoading: false,

            cgInfoDataType: 'week',
            cgTableData: [],
            cgTableLoading: false,

            projectUserList:  [],
            projectUserLoading: false,
            curUserId:'',
            weeklyListLoading: false,
            weeklyList: [],
            weeklyType: 'first_week',

            disDialogVisible: false,
            disDialogTitle: '',

            baseTabLoading: false,
            baseTabData: ''
        };
    },
    components: {
        Siri
    },
    computed: {
        getYear: function() {
            return this.globalYearMonth.split('-')[0];
        },
        getMonth: function() {
            return this.globalYearMonth.split('-')[1];
        }
    },
    created() {
        this.fetchProjectList();
    },
    methods: {
        showInfoDialog(row,type,infoDataType){
            this.store.params.projectId = this.curProjectId;
            this.store.params.projectId_sub = row.projectId;
            this.store.params.yearMonth = this.globalYearMonth;
            this.store.params.dateType = infoDataType;
            this.store.params.conpanyId = this.curCompany.id;
            this.store.params.saleMainId = row.saleMainId;
            this.store.params.publicId = row.publicId;
            if(type===1){
                this.store.params.queryType = 'fx';
                this.store.reload();
                this.disDialogTitle = '分销订单明细';
                this.disDialogVisible = true;
            }else if(type===3){
                this.store.params.queryType = 'cwsr';
                this.store.reload();
                this.disDialogTitle = '财务收入明细';
                this.disDialogVisible = true;
            }else if(type===2){
                console.log(this.$options)
                this.$alert(`<div class="m-b-10">正毛利：${ this.$options.filters.moneyFormat(row.z_mlMoney) }</div>
                    <div>负毛利：${ this.$options.filters.moneyFormat(row.f_mlMoney) }</div>`, '毛利明细', {
                    dangerouslyUseHTMLString: true
                });
            }else if(type===4){
                this.store.params.queryType = 'cg';
                this.store.reload();
                this.disDialogTitle = '采购订单明细';
                this.disDialogVisible = true;
            }
        },
        checkProject(projectId){
            if(this.curProjectId === projectId){
                return;
            }
            this.curProjectId = projectId;
            this.projectChange();
        },
        projectChange(){
            this.getIdcProjectBaseInfo();
            this.getIdcProjectSumMoney();
            this.getSubProjectSaleData();
            this.getSubProjectCgData();
            this.queryWeeklyByProject();
            this.getIdcProjectMemberLists();
        },
        fetchProjectList() {
            this.projectLoading = true;
            this.$http
                .post(this.$api.getIdcProjectList.url)
                .then(res => {
                    this.projectList = res.data || [];
                    this.projectLoading = false;
                    if(this.projectList[0]){
                        this.curProjectId = this.projectList[0].projectId;
                        this.projectChange();
                    }
                })
                .catch(err => {});
        },
        getIdcProjectBaseInfo(){
            this.baseLoading = true;
            this.$http
                .post(this.$api.getIdcProjectBaseInfo.url,{
                    projectId: this.curProjectId
                })
                .then(res => {
                    this.baseInfo = res.data || '';
                    this.baseLoading = false;
                })
                .catch(err => {});
        },
        getIdcProjectSumMoney(){
            this.baseTabLoading = true;
            this.$http
                .post(this.$api.getIdcProjectSumMoney.url,{
                    projectId: this.curProjectId
                })
                .then(res => {
                    this.baseTabData = res.data || {};
                    this.baseTabLoading = false;
                })
                .catch(err => {});
        },
        getSubProjectSaleData(fxInfoDataType){
            if(!fxInfoDataType){ fxInfoDataType = this.fxInfoDataType } 
            this.fxInfoDataType = fxInfoDataType;
            this.fxTableLoading = true;
            this.$http
                .post(this.$api.getSubProjectSaleData.url,{
                    projectId: this.curProjectId,
                    dateType: this.fxInfoDataType,
                    conpanyId: this.curCompany.id,
                    yearMonth: this.globalYearMonth
                })
                .then(res => {
                    this.fxTableData = res.data || [];
                    this.fxTableLoading = false;
                })
                .catch(err => {});
        },
        getSubProjectCgData(cgInfoDataType){
            if(!cgInfoDataType){ cgInfoDataType = this.cgInfoDataType } 
            this.cgInfoDataType = cgInfoDataType;
            this.cgTableLoading = true;
            this.$http
                .post(this.$api.getSubProjectCgData.url,{
                    projectId: this.curProjectId,
                    dateType: this.cgInfoDataType,
                    conpanyId: this.curCompany.id,
                    yearMonth: this.globalYearMonth
                })
                .then(res => {
                    this.cgTableData = res.data || [];
                    this.cgTableLoading = false;
                })
                .catch(err => {});
        },
        queryWeeklyByProject(){ 
            this.weeklyListLoading = true;
            this.$http
                .post(this.$api.queryWeeklyByProject.url,{
                    projectId: this.curProjectId,
                    userId: this.curUserId,
                    type: this.weeklyType
                })
                .then(res => {
                    this.weeklyList = res.data || [];
                    this.weeklyListLoading = false;
                })
                .catch(err => {});
        },
        loadMore(){
            this.weeklyType = '';
            this.queryWeeklyByProject();
        },
        getIdcProjectMemberLists(){ 
            this.projectUserLoading = true;
            this.$http
                .post(this.$api.getIdcProjectMemberLists.url,{
                    projectId: this.curProjectId,
                })
                .then(res => {
                    this.projectUserList = res.data || [];
                    this.projectUserLoading = false;
                })
                .catch(err => {});
        },
        companyChange(con) {
            this.curCompany = con;
            //重载与公司相关的数据
            this.getSubProjectSaleData();
            this.getSubProjectCgData();
        },
        globalDateChange(date) {
            //重载与全局时间相关的数据
            this.globalYearMonth = date;
            // 如果切换到不是本月，那么业务数据不展示本周，切换到月，且禁用本周tab
            if(this.curYearMonth !== this.globalYearMonth && this.fxInfoDataType === 'week'){
                this.getSubProjectSaleData('month')
            }else{
                this.getSubProjectSaleData();
            }
            if(this.curYearMonth !== this.globalYearMonth && this.cgInfoDataType === 'week'){
                this.getSubProjectCgData('month')
            }else{
                this.getSubProjectCgData();
            }
        },
        cgEndRowClassName({ row, rowIndex }) {
            if (rowIndex+1 === this.cgTableData.length) {
                return 'warning-row';
            }
        },
        fxEndRowClassName({ row, rowIndex }) {
            if (rowIndex+1 === this.fxTableData.length) {
                return 'warning-row';
            }
        },
        handleCurrentChange(page) {
            this.store.params.page = page;
            this.store.load();
        },
        copyString(str){
            this.$copyText(str).then(()=>{
                this.$message.success('订单号已复制到剪切板')
            })
        },
    }
};
</script>

<style lang="less">
.project-progress_page {
    .el-input--suffix .el-input__inner {
        padding-right: 0;
        color: #3D4EFF;
    }
    .valid-area{
        margin-left: auto;
        margin-right: auto;
    }
    .mod-title {
        position: relative;
        font-size: 22px;
        padding-left: 12px;
        &::after {
            content: ' ';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 22px;
            background-color: #1a1a1a;
        }
    }
    .table-mod{
        padding: 20px 16px 28px;
        margin-bottom: 24px;
        background-color: #fff;
        border-radius: 16px;
        .title{
            margin-bottom: 24px;
            .icon{
                width: 24px;
                height: 24px;
                margin-right: 3px;
            }
        }
    }
    .row{
        &.row-width{
            width: 300px;
        }
        .label{
            width: 93px;
            text-align: right;
        }
        .value{
            line-height: 1.5;
        }
    }
    .empty {
        text-align: center;
        color: #999;
    }
    .project-list{
        gap: 8px 1.5%;
    }
    .project{
        width: 13%;
        padding: 12px 8px;
        text-align: center;
        background: #FFFFFF;
        color: #808080;
        border-radius: 8px 8px 0px 0px;
        opacity: 0.8;
        cursor: pointer;
        position: relative;
        transition: all 300ms;
        &::after{
            content: '';
            width: 100px;
            height: 3px;
            background: #fff;
            font-weight: 700;
            border-radius: 2px;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            transition: all 300ms;
        }
        &.cur{
            color: #3D4EFF;
            &::after{
                background: #3D4EFF;
            }
        }
    }
    .arr{
        width: 0;
        height: 0;
        border: transparent 6px solid;
        border-left-color: #3D4EFF;
        border-radius: 4px;
        margin-left: 6px;
    }
    .warning-row{
        font-weight: 600;
    }
    .el-table .hlg {
        color: #f36f52;
    }
    .el-table .green {
        color: #0CA867;
    }
    .el-table .warning-row {
        background: #F0F5FF;
    }
}
.tabs{
    .tab{
        width: 31%;
        height: 140px;
        padding: 24px;
        border-radius: 8px;
        &.tab1{
            background: #FBF5FF;
        }
        &.tab2{
            background: #FFFBF5;
        }
        &.tab3{
            background: #F5F6FF;
        }
    }
    .data-item{
        width: 50%;
        padding-right: 24px;
    }
}
/* 报告流水 */
.info-list{
    color: #808080;
    .empty-weekly{
        height: 96px;
        background: #F7F7F7;
        border-radius: 8px;
        padding: 16px 24px;
    }
}
.info-list .title-month{
    font-size: 18px;
    margin-bottom: 24px;
    font-weight: bold;
}
.info-list .week{
    position: relative;
    padding-left: 30px;
    padding-bottom: 24px;
}
.info-list .week .border-lf{
    position: absolute;
    left: 6px;
    top: 8px;
    height: 100%;
    border-left: 1px dashed #e0e0e0;
}
.info-list .week::after{
    content: " ";
    display: block;
    position: absolute;
    top: 2px;
    left: 2px;
    width: 9px;
    height: 9px;
    border-radius: 100%;
    background-color: #e0e0e0;
}
.info-list .week:last-child .border-lf{
    display: none;
}
.info-list .title-week{
    margin-bottom: 15px;
    font-weight: bold;
}
.info-list .department,
.info-list .msg-container{
    background-color: #FAFAFA;
    border-radius: 8px;
    padding: 16px 24px;
    margin-bottom: 16px;
}
.info-list .title-department,
.info-list .title-msg{
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: bold;
}
.info-list .user{
    position: relative;
}
.info-list .user:not(:last-child){
    margin-bottom: 16px;
}
.info-list .user .label{
    position: absolute;
    left: 0;
    top: 0;
    width: 62px;
}
.info-list .user .val{
    padding-left: 62px;
    line-height: 1.4;
}
.info-list .msg-container .val{
    line-height: 1.4;
    padding-bottom: 6px;
    padding-top: 14px;
}
/* 报告流水当前月样式 */
.month.cur .title-month{
    color: #3D4EFF;
}
.month.cur .week.cur .border-lf{
    border-left: 1px dashed #3D4EFF;
}
.month.cur .week.cur::after{
    background-color: #3D4EFF;
    box-shadow: 0 0 2px 4px rgba(51,114,224,.3);
}
.month.cur .week.cur .title-week,
.month.cur .week.cur .title-msg{
    color: #333;
}
.month.cur .week.cur .department{
    color: #fff;
}
.month.cur .week.cur .department.blue{
    background:linear-gradient(90deg,rgba(91,116,246,1) 0%,rgba(127,126,247,1) 100%);
}
.month.cur .week.cur .department.blue-light{
    background:linear-gradient(90deg,rgba(135,128,247,1) 0%,rgba(171,138,248,1) 100%);
}
.month.cur .week.cur .department.blue-lighter{
    background:linear-gradient(90deg,rgba(178,140,248,1) 0%,rgba(238,143,174,1) 100%);
}
.load-more{
    padding-left: 32px;
    color: #3D4EFF;
    cursor: pointer;
}
.icon-more{
    width: 16px;
    margin-right: 8px;
}
</style>
